import {Component, Input} from '@angular/core';
import {GaugeCircleChartData} from '../../../models/influencer';
import {CircleChartData} from '../../../models/chart';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'list-gauge-circle-chart',
  templateUrl: './list-gauge-circle-chart.component.html',
  styleUrls: ['./list-gauge-circle-chart.component.scss']
})
export class ListGaugeCircleChartComponent {

  static readonly CUSTOM_PLATFORM_COLORS = [
    {platform: 'blogs', colorIndex: 0},
    {platform: 'instagram', colorIndex: 1},
    {platform: 'youtube', colorIndex: 2},
    {platform: 'tiktok', colorIndex: 3},
    {platform: 'pinterest', colorIndex: 4},
    {platform: 'snapchat', colorIndex: 5},
    {platform: 'twitter', colorIndex: 6},
    {platform: 'facebook', colorIndex: 7}
  ];

  @Input()
  public charts: GaugeCircleChartData[];
  @Input()
  public titlePosition: string;
  @Input()
  public hasBorderLeft = true;
  @Input()
  public showReachLabel = false;
  @Input()
  public fixedLineColor: string;
  @Input()
  public chartHeader: string;
  @Input()
  public titleTooltip: string;
  @Input()
  public statusTooltip: string;
  @Input()
  public isChannelFollower = false;

  constructor(private translate: TranslateService, private userService: UserService) {}

  getChartContent(chart: GaugeCircleChartData, index): CircleChartData {
    const circleChartData = new CircleChartData();
    circleChartData.name = chart.progressBar.name;
    circleChartData.value = chart.progressBar.value;
    circleChartData.lineColor = this.fixedLineColor ? this.fixedLineColor : this.setChartLineColor(chart, index);
    return circleChartData;
  }

  hasLeftBorderLine(i) {
    return this.hasBorderLeft && i % 4 !== 0;
  }

  calculateSpacingBottom() {
    return this.titlePosition === 'top' ? 15 : 38;
  }

  calculateSpacingTop() {
    return this.titlePosition === 'top' ? 25 : 15;
  }

  calculateHeight() {
    return this.titlePosition === 'top' ? 200 : 218;
  }

  getReachLabel() {
    return this.showReachLabel ? this.translate.instant('measure.reach_label') : undefined;
  }

  private setChartLineColor(chart: GaugeCircleChartData, index) {
    if (!chart.platformName) {
      return this.userService.chartColors[index];
    } else {
        const plaformColor = ListGaugeCircleChartComponent.CUSTOM_PLATFORM_COLORS.find(pc => pc.platform === chart.platformName);
        return plaformColor ? this.userService.chartColors[plaformColor.colorIndex].toLowerCase() : null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/list-gauge-circle-chart/list-gauge-circle-chart.component.ts